module.exports = __webpack_public_path__ + "img/visa.3bd91dfb.png";